module.exports = __webpack_public_path__ + "static/media/list.c1604861.svg";